/** Matches backend suggested companies (same fields as `ICPAccount`). */
export type OnboardingSuggestedAccount = {
  company_name: string;
  website_domain: string;
};

/** JSON body for `POST /v1/onboarding/signals/save`. */
export type OnboardingSignalsSaveRequest = {
  companies: OnboardingSuggestedAccount[];
  instructions: string[];
  prioritization_message: string;
};

export type OnboardingWizardSaveInput = {
  companies: OnboardingSuggestedAccount[];
  signalInstructions: string[];
  prioritizationValidatedMessage: string;
};

export function toOnboardingSignalsSaveRequest(
  input: OnboardingWizardSaveInput
): OnboardingSignalsSaveRequest {
  return {
    companies: input.companies,
    instructions: input.signalInstructions,
    prioritization_message: input.prioritizationValidatedMessage.trim()
  };
}
